import CollegeLogo from "rivals/components/shared/CollegeLogo";
import RivalsDivider from "rivals/components/shared/Divider";
import RivalsLink from "rivals/components/shared/Link";
import styles from "./Team.module.scss";
import strings from "./strings";
import type { Props, TeamLinkProps } from "./types";

const { commitListLink, forumsLink, transferTrackerLink } = strings;

/**
 * @param name string (team name college or highschool)
 * @returns string (team name but without white spaces and lowercased)
 */
const formatForDataPhilter = (name: string): string =>
  name.replace(/\s/g, "").toLowerCase();

const TeamLink = ({
  addDivider = true,
  className,
  hideIfNotExistent = true,
  name,
  text,
  url
}: TeamLinkProps): JSX.Element | null => {
  const initialNoneDisplayCondition = !(url && name && text);
  if (initialNoneDisplayCondition && hideIfNotExistent) {
    return null;
  }

  return (
    <>
      {addDivider && (
        <RivalsDivider className={styles.divider} type="vertical" />
      )}
      <RivalsLink
        className={className}
        data={formatForDataPhilter(`${name}-site-home`)}
        disabled={initialNoneDisplayCondition}
        href={url || ""}
      >
        {text}
      </RivalsLink>
    </>
  );
};

const Team = ({ team }: Props): JSX.Element => (
  <div className={styles.teamWrapper}>
    <CollegeLogo
      applyDarkBackground
      collegeLogo={team.logo}
      collegeName={team.name}
      collegeSiteColor={team.color}
      logoSize={60}
    />
    <div className={styles.description}>
      <TeamLink
        addDivider={false}
        className={styles.primaryLink}
        name={team.name}
        text={team.name}
        url={team?.seoUrls?.siteHomeUrl}
      />
      <TeamLink
        addDivider={false}
        className={styles.forumsLink}
        hideIfNotExistent={false}
        name={team.name}
        text={forumsLink}
        url={team?.seoUrls?.forumsUrl}
      />
      <TeamLink
        className={styles.commitmentsLink}
        name={team.name}
        text={commitListLink}
        url={team?.seoUrls?.commitListUrl}
      />
      <TeamLink
        className={styles.transferTrackerLink}
        name={team.name}
        text={transferTrackerLink}
        url={team?.seoUrls?.transferTrackerUrl}
      />
    </div>
  </div>
);

export default Team;
